import classNames from 'classnames';
import { ReactNode, useCallback } from 'react';
import { Button, ButtonProps } from 'yoso';
import { useLogin } from '~/components/Auth/Auth.hooks';
import { Wallet } from '~/components/Icon';

export type LoginButtonProps = {
  children?: ReactNode;
} & ButtonProps;
export const LoginButton = ({ className, children = <Wallet />, ...props }: LoginButtonProps) => {
  const login = useLogin();
  const onClick = useCallback(() => {
    login();
  }, [login]);
  return (
    <Button
      className={classNames('login-button', className)}
      variant="transparent"
      onClick={onClick}
      {...props}>
      {children}
    </Button>
  );
};
